import React from 'react';
import Col from './col';
const Row = ({ data = {}, transformFn = () => {}, actions = {}, openModalChangeToInspection = () => {}, isViewer }) => {
    const resultTransform = transformFn(data);
    return (
        <tr>
            {
                resultTransform.map((col, index) => (
                    <Col {...col} key={index} actions={actions} openModalChangeToInspection={openModalChangeToInspection} isViewer={isViewer} />
                ))
            }
        </tr>
    );
};

export default Row;



// WEBPACK FOOTER //
// ./src/components/shared/table/row.jsx